<template>
  <div class="layout" id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { log } from "three";
export default {
  name: "App",
  data() {
    return {
      currentRoute: ""
    };
  },
  created() {
    var seen = [];
    var replacer = function(key, value) {
      if (value != null && typeof value == "object") {
        if (seen.indexOf(value) >= 0) {
          return;
        }
        seen.push(value);
      }
      return value;
    };
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem(
        "store",
        JSON.stringify(this.$store.state, replacer)
      );
    }); // 在页面加载时读取sessionStorage里的状态信息

    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
  },
  methods: {
    // 监测当前环境
    testEnv() {
      this.currentRoute = this.$router.path;
      console.log(`当前环境: ${process.env.NODE_ENV}`);
    },
    // 判断是否是移动设备
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  mounted() {
    this.testEnv();
    if (
      this._isMobile() &&
      (this.currentRoute === "/home/m_index" ||
        this.currentRoute === "/home/index")
    ) {
      this.$router.replace("/home/m_index");
    } else if (
      !this._isMobile() &&
      (this.currentRoute === "/home/m_index" ||
        this.currentRoute === "/home/index")
    ) {
      this.$router.replace("/home/index");
    }
  },

  watch: {
    $route(to, from) {
      const routerName = this.$store.state.tagsView.visitedViews.find(item => {
        return item.name === from.name;
      });
      const routerToName = this.$store.state.tagsView.visitedViews.find(
        item => {
          return item.name === to.name;
        }
      );
      if ("keepAlive" in to.meta) {
        // if(to.name!=='firstInspectionDetail'&&to.name!=='firstInspectionFinishedDetail'&&from.name!=='firstInspection'){
        //   console.log('ppp');
          to.meta.keepAlive = true;
          // console.log(this.$vnode.parent.componentInstance);
          // this.$vnode.parent.componentInstance.cache={};
          // this.$vnode.parent.componentInstance.keys=[];
        // }
      }
      if ("keepAlive" in from.meta) {
        if (routerName === undefined) {
          from.meta.keepAlive = false;
        } else {
          from.meta.keepAlive = true;
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "comment/font/font.css";
#app {
  min-width: 1024px;
}
.v-transfer-dom /deep/ {
  .ivu-drawer-wrap .ivu-drawer {
    width: 500px !important;
    .ivu-drawer-content {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 150px;
      right: 0;
      bottom: 0;
      background-color: #fff;
      border: 0;
      background-clip: padding-box;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      .ivu-drawer-body .modal-area {
        .ma-top {
          .mat {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .title {
              height: 40px;
              line-height: 40px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
            }
            .devState {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: rgba(230, 0, 0, 1);
            }
          }
          .mat-table {
            width: 100%;
            table {
              width: 100%;
            }
            table tbody tr {
              height: 30px;
              line-height: 30px;
              border: 1px solid rgba(223, 223, 223, 1);

              .td1 {
                width: 33.3%;
                background: rgba(238, 238, 238, 1);
                text-align: center;
                border: 1px solid rgba(223, 223, 223, 1);
              }
              .td2 {
                width: 66.7%;
                text-align: center;
                border: 1px solid rgba(223, 223, 223, 1);
                border-left: none;
              }
            }
          }
        }
        .ma-bottom {
          .mat {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .title {
              height: 40px;
              line-height: 40px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
            }
            .devState {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: rgba(230, 0, 0, 1);
            }
          }
          .mat-table {
            width: 100%;
            table {
              width: 100%;
            }
            table thead tr {
              height: 30px;
              line-height: 30px;
              border: 1px solid rgba(223, 223, 223, 1);
              th {
                width: 33.3%;
                background: rgba(238, 238, 238, 1);
                text-align: center;
                border: 1px solid rgba(223, 223, 223, 1);
              }
            }
            table tbody tr {
              height: 30px;
              line-height: 30px;
              border: 1px solid rgba(223, 223, 223, 1);
              td {
                width: 33.3%;
                text-align: center;
                border: 1px solid rgba(223, 223, 223, 1);
              }
            }
          }
        }
      }
    }
  }
}
.ivu-table-sort i {
  display: block;
  height: 6px !important;
  line-height: 6px !important;
  overflow: hidden;
  position: absolute;
  color: #c5c8ce;
  transition: color 0.2s ease-in-out;
  font-size: 16px;
}
.ivu-message {
  z-index: 99999 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue